import { Link } from "react-router-dom";
import { ReactComponent as Email } from "../../../img/Section/Email.svg";
import Logo from "../../../img/NavBar/Dgreat Allot Pensions Logo.png";
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { Container, InputFieldWithIcon } from "../../../utils/CustomComponents";
import { useState } from "react";
function Footer() {
    // input value for email
    const [text, setText] = useState("");
    return (
        <div id="footer">
            <Container>
                <div className="footer_top">
                    <div className="grid">
                        <div className="grid_item logo_wrapper">
                            <div className="logo">
                                <img src={Logo} alt="logo" />
                            </div>
                        </div>
                        <div className="grid_item quick_links">
                            <h4>Company</h4>
                            <Link to="contact">Contact Us</Link>
                            <Link to="about">About</Link>
                            <Link to="mission">Mission</Link>
                        </div>
                        <div className="grid_item news_letter">
                            <h4>Stay in Touch</h4>
                            <p>
                                Subscribe to our newslettter and we will notify you about latest new
                                in the crypto and penson
                            </p>
                            <form>
                                <InputFieldWithIcon
                                    value={text}
                                    setValue={setText}
                                    icon={<Email />}
                                    button={true}
                                    name="newsletter"
                                    placeholder="Email"
                                    type="email"
                                />
                            </form>
                        </div>
                    </div>
                </div>
            </Container>
            <Container>
                <div className="footer_bottom">
                    <p className="copy">Copyright 2021 by enterscale. All right reserved</p>
                    <div className="social_links">
                        <div className="icon_wrapper">
                            <FaFacebookF />
                        </div>
                        <div className="icon_wrapper">
                            <FaInstagram />
                        </div>
                        <div className="icon_wrapper">
                            <FaTwitter />
                        </div>
                        <div className="icon_wrapper">
                            <FaLinkedinIn />
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default Footer;
